module.exports = __webpack_public_path__ + "img/dashed-arrow1.2ead78a.png";